import api from "../services/authService";

// Every kept version of a document, newest first, plus whether this
// document can be reverted at all (SharePoint-held Word files cannot).
export const fetchDocumentVersions = (documentId) =>
  api.get(`/documents/${documentId}/versions/`);

// Bring an earlier version back. The server keeps the file being replaced
// and records the result as a NEW, higher version, so a revert can be undone.
export const restoreDocumentVersion = (documentId, version) =>
  api.post(`/documents/${documentId}/versions/${version}/restore/`);
